export default "__VITE_ASSET__kVc_2BS5__"